import Head from 'next/head'
import { useRouter } from 'next/router'

import { RightSideContent } from '~/ui/containers/base/base'
import { EntityIdFilter } from '~/ui/containers/common/triggerActionFilterBar'
import McpServerScreen from '~/ui/screens/mcp'
import { withAuth } from '~/utils/hoc'
import { formatActionName } from '~/utils/string'

function MCPServersListPage() {
  const router = useRouter()
  const { query } = router

  return (
    <>
      <Head>
        <title>Active MCP Servers | Composio</title>
      </Head>
      <RightSideContent
        header={
          <div className="flex w-full items-center justify-between">
            <div>
              <span className="min-w-[120px] text-black-200">
                {formatActionName('Active MCP Servers')}
              </span>
            </div>
          </div>
        }
      >
        <div className="mr-2 mt-4 flex w-full items-center justify-start pl-4">
          <span className="mr-2 text-[13px] text-black-200">Filter by: </span>
          <EntityIdFilter />
        </div>
        <div>
          <div className={'w-full pb-10'}>
            <McpServerScreen
              appName={'mcp'}
              connectedAccountId={query.connectedAccountId as string}
            />
          </div>
        </div>
      </RightSideContent>
    </>
  )
}

export default withAuth(MCPServersListPage)
